var exports = {
  "kL": "x127c5a35--e7a688--container",
  "Qs": "x127c5a35--e7a688--content",
  "DD": "x127c5a35--e7a688--title",
  "h_": "x127c5a35--e7a688--description",
  "h5": "x127c5a35--e7a688--status",
  "Uo": "x127c5a35--e7a688--buttons",
};

module.exports = exports;
